export type ShapeMode = 'circle' | 'square' | 'triangle' | 'hexagon';

type ShapeProps = {
	mode: ShapeMode;
	className?: string;
	fill?: string;
	width?: number | string;
	height?: number | string;
	stroke?: string;
	strokeWidth?: number
}

const Shape = (props: ShapeProps) => {
	const height = props.height || 14;
	const width = props.width || 14;
	const styleAttributes = {
		fill: props.fill || 'black',
		stroke: props.stroke || 'black',
		strokeWidth: props.strokeWidth || 0.65,
	};

	return (
		<svg
			className={`widesk-shape widesk-shape-${props.mode} ${props.className}`}
			height={height}
			viewBox="0 0 10 10"
			width={width}
		>
			{props.mode === 'circle' && (
				<circle cx="5" cy="5" r="4.25" {...styleAttributes} />
			)}
			{props.mode === 'square' && (
				<rect x="1" y="1" width="8" height="8" {...styleAttributes} />
			)}
			{props.mode === 'triangle' && (
				<polygon points="5 1, 9.5 9.5, 0.5 9.5" {...styleAttributes} />
			)}
			{props.mode === 'hexagon' && (
				<polygon points="3 1, 7 1, 9.5 5, 7 9, 3 9, 0.5 5" {...styleAttributes} />
			)}
		</svg>
	);
};

Shape.Hexagon = (props: Omit<ShapeProps, 'mode'>) => <Shape mode="hexagon" {...props}/>;
Shape.Circle = (props: Omit<ShapeProps, 'mode'>) => <Shape mode="circle" {...props}/>;
Shape.Square = (props: Omit<ShapeProps, 'mode'>) => <Shape mode="square" {...props}/>;
Shape.Triangle = (props: Omit<ShapeProps, 'mode'>) => <Shape mode="triangle" {...props}/>;

export default Shape;